module.exports = __webpack_public_path__ + "static/media/3.343d642f.mp3";


//////////////////
// WEBPACK FOOTER
// ./src/audio/orgasm/3.mp3
// module id = 503
// module chunks = 0